"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupsObject = void 0;
const groups_1 = require("./groups");
exports.groupsObject = {};
groups_1.groups.forEach((e) => {
    if (exports.groupsObject[e.symbol]) {
        // eslint-disable-next-line no-console
        console.log(`The symbol ${e.symbol} is used more than once`);
    }
    exports.groupsObject[e.symbol] = e;
});
//# sourceMappingURL=groupsObject.js.map